module.exports = __webpack_public_path__ + "static/media/MS.3377e5f9.svg";